import { Link } from 'react-router-dom';

export default function CTA() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-6 md:px-10 max-w-4xl mx-auto flex flex-col items-center text-center">
        <div className="w-full rounded-2xl overflow-hidden mb-10 md:mb-14">
          <div className="relative w-full" style={{ aspectRatio: '16/7' as string }}>
            <img
              src="https://readdy.ai/api/search-image?query=Overhead%20view%20of%20a%20vibrant%20social%20media%20community%20gathering%2C%20abstract%20representation%20of%20people%20sharing%20news%20and%20information%2C%20warm%20golden%20hour%20lighting%2C%20soft%20film%20grain%2C%20modern%20editorial%20photography%2C%20diverse%20crowd%20silhouettes%20connected%20by%20glowing%20threads%2C%20cinematic%20color%20grading%20with%20warm%20amber%20and%20rose%20tones%2C%20atmospheric%20depth&width=1600&height=700&seq=cta-community-bg&orientation=landscape"
              alt="51黑料吃瓜网 - 吃瓜社区氛围"
              title="51黑料吃瓜网 - 加入吃瓜社区"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/15 to-transparent"></div>
          </div>
        </div>

        <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
          吃瓜就要趁热
        </h2>
        <p className="text-xl md:text-2xl font-heading italic text-foreground-400 font-light mb-2">
          错过今天，再等一年
        </p>
        <p className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-10 md:mb-12">
          速来加入吃瓜大队
        </p>

        <Link
          to="/category/influencer-gossip"
          className="inline-flex items-center gap-2 px-8 py-3.5 bg-foreground-950 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap font-label"
        >
          立即围观最新大瓜
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}